import request from '@/utils/request'

// 获取发展历程
export function getDevelopmentHistory(data) {
  return request({
    url: '/OfficialWebsite/getDevelopmentHistory',
    method: 'post',
    data
  })
}

// 获取车镇荣誉列表
export function getCzHonorList(data) {
  return request({
    url: '/OfficialWebsite/getCzHonorList',
    method: 'post',
    data
  })
}

// 获取车镇动态列表
export function getCzDynamicList(data) {
  return request({
    url: '/OfficialWebsite/getCzDynamicList',
    method: 'post',
    data
  })
}

// 获取相册列表
export function getAlbumList(data) {
  return request({
    url: '/OfficialWebsite/getAlbumList',
    method: 'post',
    data
  })
}3

// 获取相片列表
export function getPhotoList(data) {
  return request({
    url: '/OfficialWebsite/getPhotoList',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/all.js